<script>
import {generateUUID, percentage_format, generateData2} from "@/utils.js";
import { getOtherCampaignControlSotres} from "@/api/campaigns";
import moment from "moment";

import swal from "sweetalert";
import MarketingRecommendations from "@/view/components/campaign_analytics/MarketingRecommendations.vue";
import ControlVsTestStores from "@/view/components/campaign_analytics/ControlVsTestStores.vue";
export default {
  name: "local-market",
  props: ["form", "isNetworkData","marketing_recommendations","disabledInAbsoluteValue","campaignIsSearch","active_tab","campaignVsControlStoresMastercarddata","campaignVsControlStoresPosdata"],
  components: {
  MarketingRecommendations,
  ControlVsTestStores
  },
  data() {
    return {
      options: {},
      series: [],
      result: [],
      temp_dates: [],
      dates: [],
      hasData: false,
      baselines: baselinesData,
      campaign_start: "",
      campaign_end: ""
    };
  },
  computed: {
    
  },
  async mounted() {
    
  },
  methods: {
    onSearch(){
      console.log("Search inside controls stores invokes");
    }
  }
};
</script>

<template>
  <div>
      
    <marketing-recommendations 
      :class="disabledInAbsoluteValue ? 'absolute-val-css' : ''"
      :marketing_recommendations="marketing_recommendations"
      :form="form"     
      :isNetworkData="isNetworkData"
      :campaignIsSearch="campaignIsSearch"
      :active_tab="active_tab"
      :disabledInAbsoluteValue="disabledInAbsoluteValue"  
    ></marketing-recommendations>  
    
  </div>
</template>

<style>
.absolute-val-css .blue--text,
.absolute-val-css .green--text,
.absolute-val-css .red--text,

.absolute-val-css p,
.absolute-val-css div{
  color:#cdced5 !important
  
}
</style>